<template>
    <nav id="navbar" class="collapse navbar-collapse">
        <ul id="nav">
            <!--<li class="current-menu-item"><a href="#">Home</a>-->
            <!--<ul class="sub-menu">-->
            <!--<li><a href="index-1.html">Home Version 01</a></li>-->
            <!--<li><a href="index-2.html">Home Version 02</a></li>-->
            <!--</ul>-->
            <!--</li>-->
            <!--<li><a href="#">hosting</a>-->
            <!--<ul class="sub-menu">-->
            <!--<li><a href="webHosting.html">web hosting</a></li>-->
            <!--<li><a href="cloudHosting.html">cloud hosting</a></li>-->
            <!--<li><a href="vpnHosting.html">vpn hosting</a></li>-->
            <!--<li><a href="sharedHosting.html">shared hosting</a></li>-->
            <!--</ul>-->
            <!--</li>-->
            <!--<li><a href="domainSearch.html">domain</a></li>-->
            <li class="dropdown-megamenu"><a href="#">Empresas</a>
                <ul class="mega-menu clearfix business-megamenu">
                    <li class="mMenuCol">
                        <ul class="menuRow">
                            <li>
                                <router-link :to="{name: 'bus-solutions'}">Soluções para empresas</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'bus-receive-payments'}">Receber pagamentos</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'bus-send-invoice'}">Enviar facturas</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'bus-pricing'}">Preçário</router-link>
                            </li>
                        </ul>
                        <ul class="menuRow">
                            <li>
                                <router-link :to="{name: 'bus-faq'}">FAQ</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'contact'}">Contacto</router-link>
                            </li>
                        </ul>
                    </li>
                    <quick-try-now-menu
                            small_text="Receba dinheiro em" big_text="segurança"
                            :action_url="settings.app_url + '/register'"
                            action_text="Experimenta já!" image_url="images/icon/serv-05.png"
                    />
                </ul>
            </li>
            <li class="dropdown-megamenu"><a href="#">Pessoal</a>
                <ul class="mega-menu clearfix">
                    <li class="mMenuCol">
                        <ul class="menuRow">
                            <li>
                                <router-link :to="{name: 'per-how-to'}">Como funciona</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'per-online-payment'}">Pagamento Online</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'per-send-payment'}">Enviar pagamento</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'per-request-payment'}">Requisitar pagamento</router-link>
                            </li>
                        </ul>
                        <ul class="menuRow">
                            <li>
                                <router-link :to="{name: 'per-faq'}">FAQ</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'contact'}">Contacto</router-link>
                            </li>
                        </ul>
                    </li>
                    <quick-try-now-menu
                            small_text="faça compras sem sair de" big_text="casa"
                            :action_url="settings.app_url + '/register'"
                            action_text="Saiba mais!" image_url="images/icon/home.png"
                    />
                </ul>
            </li>
            <li class="dropdown-megamenu"><a href="#">Desenvolvedores</a>
                <ul class="mega-menu clearfix dev-megamenu">
                    <li class="mMenuCol">
                        <ul class="menuRow">
                            <li v-for="(link, index) in developer_links" :key="index">
                                <router-link :to="{ name: link.to}">{{ link.name }}</router-link>
                            </li>
                        </ul>
                        <ul class="menuRow">
                            <li>
                                <router-link :to="{name: 'dev-faq'}">FAQ</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'contact'}">Contacto</router-link>
                            </li>
                        </ul>
                    </li>
                    <quick-try-now-menu
                            small_text="quer contribuir nos nossos" big_text="projectos?"
                            :action_url="settings.app_url + '/register'"
                            action_text="Regista-te já!" image_url="images/icon/users.png"
                    />
                </ul>
            </li>
            <li>
                <router-link :to="{name: 'support'}">Suporte</router-link>
            </li>
            <li>
                <router-link :to="{name: 'blog'}">Blog</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
  import QuickTryNowMenu from '../tryNowMenu'
  import DeveloperLinks from '../../database/developers_links'
  import Settings from '@/database/settings.json'
  import megaMenu from '../../assets/js/mega-menu'

  export default {
    components: {QuickTryNowMenu},
    data() {
      return {
        developer_links: DeveloperLinks,
        settings: Settings
      }
    },
    name: 'site-menu',
    mounted() {
      megaMenu()
    }
  }
</script>

<style scoped>
    header nav#navbar > ul {
        border-right: none;
    }

    header nav#navbar ul > li.dropdown-megamenu .business-megamenu {
        width: 520px;
    }

    header nav#navbar ul > li.dropdown-megamenu .dev-megamenu {
        width: 453px;
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SiteMenu.vue